import * as React from "react"
import { getProfessorDashboard } from "../auth/api"
import UserProfileDetails from "../components/UserProfileDetails"
import EditProfileModal from "../components/EditProfileModal"
import ChangePasswordModal from "../components/ChangePasswordModal"
import HamburgerMenu from "../components/HamburgerMenu"
import StudentManagement from "../components/StudentManagement"
import PresencasScreen from "../components/PresencasScreen"

const MENU_ITEMS = [
  { value: "dashboard", label: "Painel" },
  { value: "students", label: "Gerenciar alunos" },
  { value: "presencas", label: "Presenças" },
  { value: "logout", label: "Sair" },
]

export default function ProfessorDashboard({ user, onLogout }) {
  const [data, setData] = React.useState(null)
  const [error, setError] = React.useState("")
  const [showEditProfile, setShowEditProfile] = React.useState(false)
  const [showChangePassword, setShowChangePassword] = React.useState(false)
  const [view, setView] = React.useState("dashboard")

  React.useEffect(() => {
    let mounted = true
    async function load() {
      try {
        const res = await getProfessorDashboard()
        if (mounted) setData(res)
      } catch (err) {
        if (mounted) setError(err?.message || "Erro ao carregar dados.")
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [])

  const profile = data?.profile || user

  function handleProfileSaved(updatedProfile) {
    setData((prev) => ({ ...prev, profile: updatedProfile }))
  }

  function handleMenuSelect(value) {
    if (value === "logout") {
      onLogout()
      return
    }
    setView(value)
  }

  return (
    <div className="min-h-screen w-full bg-[#00072D] text-cor-base font-semi-bold flex items-center font-oswald justify-center p-4 sm:p-6">
      {view === "dashboard" && (
        <div className="w-full max-w-3xl bg-slate-50 backdrop-blur rounded-2xl p-4 sm:p-6 shadow-2xl">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div className="min-w-0">
              <h1 className="text-2xl sm:text-3xl font-semibold break-words">
                Área do Professor
              </h1>
              <p className="text-slate-950 mt-1 break-words">
                Bem vindo(a), {profile?.nomeCompleto || user?.email}
              </p>
            </div>
            <button
              onClick={onLogout}
              className="shrink-0 self-start sm:self-auto text-sm px-4 py-2 rounded-lg bg-cor-base text-slate-100 font-semibold active:scale-[.94] active:duration-75 transition-all hover:scale-[1.05]"
              type="button">
              Sair
            </button>
          </div>

          <div className="mt-6 text-slate-950">
            {error ? (
              <div className="text-red-700">{error}</div>
            ) : profile ? (
              <UserProfileDetails profile={profile} />
            ) : (
              <div className="text-slate-950">Carregando dados...</div>
            )}
          </div>
          <div className="flex flex-wrap justify-end gap-3 mt-4">
            <button
              onClick={() => setShowEditProfile(true)}
              className="px-4 py-2 rounded-lg bg-cor-base text-slate-100 font-semibold active:scale-[.94] active:duration-75 transition-all hover:scale-[1.05]"
              type="button">
              Alterar dados
            </button>
            <button
              onClick={() => setShowChangePassword(true)}
              className="px-4 py-2 rounded-lg border-2 border-cor-base text-cor-base font-semibold active:scale-[.94] active:duration-75 transition-all hover:scale-[1.05]"
              type="button">
              Alterar senha
            </button>
          </div>
        </div>
      )}

      {view === "students" && (
        <StudentManagement onBack={() => setView("dashboard")} />
      )}

      {view === "presencas" && (
        <PresencasScreen onBack={() => setView("dashboard")} />
      )}

      <HamburgerMenu items={MENU_ITEMS} active={view} onSelect={handleMenuSelect} />

      {showEditProfile && (
        <EditProfileModal
          profile={profile}
          onClose={() => setShowEditProfile(false)}
          onSaved={handleProfileSaved}
        />
      )}

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </div>
  )
}
